module.exports = __webpack_public_path__ + "img/zany_face.8948e11a.gif";